import { useInView } from '@cian/valuation-utils-component';
import * as React from 'react';
import { useDispatch } from 'react-redux';

import { toggleStickyFooterVisible } from '../../../actions/page';
import { checkHasData, useEstimationHistoryQuery } from '../../../serverState/estimationHistory';

/**
 * Следит за видимостью главной кнопки (btnOnPageInViewRef) и в зав-ти от этого открывает/закрывает футер
 * Футер откроется сразу, если есть история оценок
 * */
export const useStickyFooterControl = () => {
  const dispatch = useDispatch();
  const { data } = useEstimationHistoryQuery();
  const hasPrevEstimations = React.useMemo(() => checkHasData(data), [data]);
  const { ref: btnOnPageInViewRef, inView, entry } = useInView({ triggerOnce: false, initialInView: false });

  React.useEffect(() => {
    if (hasPrevEstimations) {
      dispatch(toggleStickyFooterVisible(true));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    /** Проверка на entry предотвращает лишнее срабатывание, когда ref еще не назначено */
    if (entry) {
      dispatch(toggleStickyFooterVisible(!inView));
    }
  }, [entry, dispatch, inView]);

  return { btnOnPageInViewRef };
};
